import { Icon, ICONS } from '@creditsights/styleguide-web';
import { ReactElement, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { NavLink } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { LockedContent } from '@creditsights/creditsights-web';
import { DOC_SCORE_EU_SLIDES, DOC_SCORE_US_SLIDES, DOC_SCORES_EU_ROUTE, DOC_SCORES_US_ROUTE, ICON_MAP, DOC_SCORE_US_FILES, DOC_SCORE_EU_FILES } from '../../../Constants';
import './DocScore.scss';
import '../../../scss/header-ctx.scss';
import useFetchUserPermissions from '../../../hooks/user/useFetchUserPermissions';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function DocScore({ region }): ReactElement {
  const client = useQueryClient();
  const [slides, setSlides] = useState<any[]>([]);
  const [files, setFiles] = useState<any[]>([]);
  const { data: userPermissions } = useFetchUserPermissions();

  useEffect(() => {
    setSlides([]);
    setTimeout(() => setSlides(region === 'us' ? DOC_SCORE_US_SLIDES.slice() : DOC_SCORE_EU_SLIDES.slice()), 100);
  }, [region]);

  useEffect(() => {
    const files = region === 'us' ? DOC_SCORE_US_FILES : DOC_SCORE_EU_FILES;
    const accessibleFiles = files.filter((f) => !f.permission || userPermissions?.permissions.includes(f.permission));
    setFiles(accessibleFiles);
  }, [region, userPermissions]);

  const scrollToView = (index) => {
    slides.forEach((slide, slideIndex) => {
      // eslint-disable-next-line no-param-reassign
      slide.active = slideIndex === index;
    });

    const target = document.getElementById(`title-slide-${index + 1}`);
    if (target) {
      const parent = target.parentElement;
      if (parent) {
        parent.scrollTop = 0;
        const box = target.getBoundingClientRect();
        const parentBox = parent.getBoundingClientRect();
        parent.scrollTop = box.top - parentBox.top;
      }
    }

    setSlides([...slides]);
  };

  const openFile = (url) => {
    if (url) {
      window.open(url);
    }
  };

  if (userPermissions && !userPermissions.hasAccessToDataTools()) {
    return <LockedContent client={client} />;
  }

  return (
    <div className="cs-doc-score-ctx">
      <div className="header-ctx">
        <div className="ctx">
          <div className="header">
            <div className="title">Documentation Scores</div>
            <div className="separator" />
            <div className="nav-links">
              <NavLink to={DOC_SCORES_US_ROUTE}>US Loans</NavLink>
              <NavLink to={DOC_SCORES_EU_ROUTE}>EU Loans</NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="body-ctx">
        <div className="ctx">
          <div className="doc-score-region-ctx">
            <div className="navigation">
              {slides.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`item-${index}`} className={`link ${item.active ? 'active' : 'inactive'}`} onClick={() => scrollToView(index)}>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="content-ctx">
              <div className="files">
                {files.map((file) => (
                  <div className="file" onClick={() => openFile(file.url)} key={file.title}>
                    <div className="icon">
                      <Icon name={ICONS[ICON_MAP[file.extension]]} height={32} width={24} />
                    </div>
                    <div className="name">{file.title}</div>
                  </div>
                ))}
              </div>
              {slides.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`content-${index}`} id={`title-slide-${index + 1}`} className="content">
                  <div className="section-title">{item.title}</div>
                  <div className="text" dangerouslySetInnerHTML={{ __html: item.content }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocScore;
